module.exports = __webpack_public_path__ + "img/bj29.56b01307.png";